import React from 'react';
import ReactDOM from 'react-dom';
import {Link, withRouter} from 'react-router';

import {
  Row,
  Col,
  Icon,
  Grid,
  Panel,
  Table,
  PanelBody,
  PanelHeader,
  PanelFooter,
  FormControl,
  PanelContainer,
  FormGroup,
  ControlLabel,
  Form,
  Well,
  InputGroup,
  Button,
  ButtonGroup,
  ButtonToolbar,
  MenuItem,
  DropdownButton,
} from '@sketchpixy/rubix';
import {routeUrl} from '../routeUrl';

import Loader from 'react-loader';
import { 
  getMessageCode,
  getMessageTexts,
  updateMessage,
  deleteMessageCode,
  getAccessToken
} from '../../api/api';
import { 
	downloadMessage
} from '../../api/url';
import ServiceType from '../../constants/ServiceType';

export default class MultilingualDetail extends React.Component {
  constructor(props) {
    super(props);

    const messageCodeId = props.params.messageCodeId;

    this.state = {
      messageCodeId: messageCodeId,
      messageCodeDetail: {
        serviceTypeName: 'COMMON', 
        messageCode: '',
        messageCodeId: ''
      },
      messageTextList: [],
    };
  }

  messageCodeChangeHandler = (event) => {
	  var messageCodeDetail = {...this.state.messageCodeDetail}
	    messageCodeDetail.messageCode = event.target.value;

	    this.setState({
	      messageCodeDetail: messageCodeDetail,
	    });
	}

  
  serviceTypeChangeHandler = (event) => {
    var messageCodeDetail = {...this.state.messageCodeDetail}
    messageCodeDetail.serviceTypeName = event.target.value;

    this.setState({
      messageCodeDetail: messageCodeDetail,
    });
  }

  messageTextChangeHandler = (event, index) => {
    var messageTextList = [...this.state.messageTextList];
    messageTextList[index].messageText = event.target.value;

    this.setState({messageTextList: messageTextList});
  }

  
  goBack = (e) => {
    this.props.router.push(`${routeUrl.multilingualMgnt}`);
  };

  downloadMessage = (evt) => {
	    let self = this;
	    let messageCodeId = this.state.messageCodeDetail.messageCodeId;
	    let accessToken = getAccessToken();
	    document.location.href = `${downloadMessage}/${messageCodeId}?access_token=${accessToken}`
	}
  
  deleteMessage = (evt) => {
    let self = this;
    let messageCodeId = this.state.messageCodeDetail.messageCodeId;
     vex.dialog.confirm({
        message: 'Are you sure to delete this item?',
        callback: function (value) {
            if (value) {
                 deleteMessageCode(messageCodeId, (err, res) => {
                    if (err) {
                        vex.dialog.alert('Failed to delete message!');
                      } else {
                        vex.dialog.alert('Message Deleted!');
                        self.goBack();
                      }
                });
            } else {
                console.log('delete cancel')
            }
        }
    });
  }


  updateMessage = () => {
     let self = this;
     let param = {};
     param.messageCode = this.state.messageCodeDetail;
     param.messageTextList = this.state.messageTextList;
     updateMessage(param, (err, res) => {
         if (err) {
            vex.dialog.alert('Failed to update message!');
          } else {
            vex.dialog.alert('Message Updated!');
            if(self.state.messageCodeId)
            {
              self.loadInitData();
            }else{
              self.props.router.push(`${routeUrl.multilingualDetail}/${self.state.messageCodeDetail.messageCodeId}`);

              self.setState({
            	  messageCodeId: self.state.messageCodeDetail.messageCodeId
              }, () => {
                self.loadInitData();
              });
            }
          }
     });
  };

  loadInitData() {
      if(this.state.messageCodeId)
      {
        getMessageCode(this.state.messageCodeId, (err, result) => {
            if (err) {
              vex.dialog.alert('can not get message.');
              this.goBack();
              return;
            } else {
                let messageCodeDetail = result.code;
                if(!messageCodeDetail.serviceTypeName)
                {
                  messageCodeDetail.serviceTypeName = 'COMMON' ;
                }

                this.setState({
                    messageCodeDetail: messageCodeDetail,
                });
            }
        });
     }

     getMessageTexts(this.state.messageCodeId, (err, result) => {
         if (err) {
         } else {
             this.setState({
                 messageTextList: result.texts,
             });
         }
     });
  }

  componentDidMount() {
      this.loadInitData();

      $(ReactDOM.findDOMNode(this.refs.datatables))
      .addClass('nowrap')
      .dataTable({
        responsive: true,
        paging: false,
        searching: false,
        ordering: false,
        bInfo : false,
        language : {
            zeroRecords: " "
        },
        columnDefs: [
            { width: 200, targets: 0 }
        ],
        fixedColumns: true
    });
  }

   renderDeleteButton() {
     let buttons;
     if(this.state.messageCodeId)
     {
    	 buttons = <Button bsStyle='brownishgray' onClick={this.deleteMessage}>Delete</Button>
     }

     return buttons;
  }
   
   renderDownloadButton() {
	     let buttons;
	     if(this.state.messageCodeId)
	     {
	    	 buttons = <Button bsStyle='brownishgray' onClick={this.downloadMessage}>Download Excel</Button>
	     }

	     return buttons;
	  }

  render() {
    return (
      <Grid>
          <Row>
            <Col sm={12}>
              <PanelContainer controls={false}>
                <Panel>
                  <PanelHeader className="bg-pinkishred fg-white">
                    <Grid>
                      <Row>
                        <Col xs={12}>
                          <h3>
                            Multilingual Management
                          </h3>
                        </Col>
                      </Row>
                    </Grid>
                  </PanelHeader>
                  <PanelBody style={{padding: 25}}>
                    <Grid>
                      <Row>
                        <Col xs={12}>
                          <Well>
                            <Form horizontal>
                               <FormGroup controlId='messageCodeId'>
                                        <Col sm={2} componentClass={ControlLabel}>Message Code</Col>
                                        <Col sm={10}>
                                            <FormControl readOnly type='text' placeholder='Message Code Id' value={this.state.messageCodeDetail.messageCodeId}/>
                                        </Col>
                                </FormGroup>
                                <FormGroup controlId='messageCodeId'>
                                    <Col sm={2} componentClass={ControlLabel}>Message Code</Col>
                                    <Col sm={10}>
                                        <FormControl onChange={this.messageCodeChangeHandler}  type='text' placeholder='Message Code' value={this.state.messageCodeDetail.messageCode}/>
                                    </Col>
                                </FormGroup>
                                <FormGroup controlId="serviceTypeSelect">
                                    <Col componentClass={ControlLabel} sm={2}>Service Type</Col>
                                    <Col sm={10}>
                                        <FormControl
                                          componentClass="select"
                                          onChange={this.serviceTypeChangeHandler}
                                          value={this.state.messageCodeDetail.serviceTypeName}
                                          >
                                          <option key='COMMON' value=''>Select</option>
                                          {
                                              ServiceType.enumValues.map(serviveType => (
                                                  <option key={serviveType.name} value={serviveType.name}>{serviveType.title}</option>
                                              ))
                                          }
                                        </FormControl>
                                    </Col>
                                </FormGroup>
                            </Form>
                          </Well>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                          <Table ref="datatables" className='display' cellSpacing='0' width='100%'>
                            <thead>
                              <tr>
                                <th>Language</th>
                                <th>Text</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                              this.state.messageTextList.map( (messageText, index)=> (
                                  <tr key={index}>
                                    <td>
                                      {messageText.localeDto.localeLanguage}_{messageText.localeDto.localeRegion}
                                    </td>
                                    <td>
                                      <FormControl componentClass='textarea' rows='3' placeholder='Message Text...' value={messageText.messageText} onChange={(event)=>this.messageTextChangeHandler(event, index)}/>
                                    </td>
                                  </tr>
                              ))
                            }
                            </tbody>
                          </Table>
                          <br />
                        </Col>
                      </Row>
                    </Grid>
                  </PanelBody>
                   <PanelFooter className='bg-pinkishred'>
                    <Grid>
                      <Row>
                        <Col xs={12} className='fg-white'>
                          <div style={{marginTop: '15px', marginBottom: '15px', float: 'right'}}>
                            <Button bsStyle='brownishgray' onClick={this.goBack} style={{marginRight: '8px'}}>List</Button>
                            {this.renderDeleteButton()}
                            <Button bsStyle='brownishgray' onClick={this.updateMessage}>Save</Button>
                            {this.renderDownloadButton()}
                            
                          </div>
                        </Col>
                      </Row>
                    </Grid>
                  </PanelFooter>
                </Panel>
              </PanelContainer>
            </Col>
          </Row>
        </Grid>
    );
  }
}




// WEBPACK FOOTER //
// ./src/routes/MultilingualMgnt/MultilingualDetail.js